export function getAllYears(startDate, endDate) {
  const years = [];
  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();

  for (let year = startYear; year <= endYear; year++) {
    years.push(new Date(year, 0, 1)); // January 1st of each year
  }

  return years;
}
